import type { Fragment } from '../translations';

export const mywork: Fragment = {
  fr: {
    'mywork.headline': '{active} processus actifs · {waiting} en attente gouvernance',
    'mywork.headlineWait': 'dont 1 depuis {n} j',
    'mywork.toTake': 'À prendre en charge',
    'mywork.take': 'Prendre en charge',
    'mywork.fromPmo': 'arrivé de PMO il y a {when}',
    'mywork.myProcesses': 'Mes processus',
    'mywork.returns': 'Retours',
    'mywork.myTickets': 'Tickets qui m\'incombent',
    'mywork.returnedBy': 'renvoyée par {name} le {date}',
    'mywork.motif': 'motif : « {motif} »',
    'mywork.empty': 'Rien ne vous attend.',
    'mywork.emptyHint': 'Derniers processus du répertoire :',
    'mywork.next.waitingGov': 'En attente gouvernance — {days} j',
    'mywork.next.gate': '{n} case(s) à cocher pour passer l\'étape {phase}',
    'mywork.next.transcripts': '{n} transcription(s) en cours',
    'mywork.next.firstSeance': 'Première séance client à programmer',
    'mywork.next.linkDiagram': 'Lier un diagramme du répertoire',
    'mywork.next.advance': 'Prêt à passer à l\'étape {phase}',
    'mywork.next.continue': 'Poursuivre l\'étape {phase}',
    'mywork.remind': 'Relancer',
  },
  en: {
    'mywork.headline': '{active} active processes · {waiting} awaiting governance',
    'mywork.headlineWait': 'incl. 1 for {n} d',
    'mywork.toTake': 'To take charge of',
    'mywork.take': 'Take charge',
    'mywork.fromPmo': 'arrived from PMO {when} ago',
    'mywork.myProcesses': 'My processes',
    'mywork.returns': 'Returns',
    'mywork.myTickets': 'Tickets assigned to me',
    'mywork.returnedBy': 'sent back by {name} on {date}',
    'mywork.motif': 'reason: "{motif}"',
    'mywork.empty': 'Nothing awaits you.',
    'mywork.emptyHint': 'Latest processes in the repository:',
    'mywork.next.waitingGov': 'Awaiting governance — {days} d',
    'mywork.next.gate': '{n} check(s) to tick to pass step {phase}',
    'mywork.next.transcripts': '{n} transcript(s) in progress',
    'mywork.next.firstSeance': 'First client session to schedule',
    'mywork.next.linkDiagram': 'Link a diagram from the repository',
    'mywork.next.advance': 'Ready to advance to step {phase}',
    'mywork.next.continue': 'Continue step {phase}',
    'mywork.remind': 'Remind',
  },
};
